import moment from 'moment'
import { get } from 'lodash'

import { checkIsDataUpdated } from '../../../../Pages/Logs/logHelper'
import { primary_color } from '../../../../Helper/uiHelper'
import { asLogRows, isLockerEditLog, lockerEditHeadline, LOCKER_EDIT_LOG_FIELDS, normalizeLockerEditRow } from './lockerEditLog'

const legacyFields = [
  {
    field_id: 'student_name',
    label: 'Student Name',
  },
  {
    field_id: 'student_surname',
    label: 'Student surname',
  },
  {
    field_id: 'item_id_label',
    label: 'Locker Name',
  },
  {
    field_id: 'location_id_label',
    label: 'Block Name',
  },
]

const headlineFor = (updatedRows) => {
  if (isLockerEditLog(updatedRows)) {
    return lockerEditHeadline(updatedRows)
  }
  return ' has moved the booking'
}

const ShowDifference = ({ data, original_data, updated_data, onExpand, fields, useLockerEditFields }) => {
  const updatedRows = asLogRows(updated_data)
  const originalRows = asLogRows(original_data)
  return (
    <div>
      <div className='permission-table'>
        <div className='mb-2 cursor-pointer' onClick={() => onExpand()}>
          <i class='fa-sharp fa-solid fa-arrow-left  m-3'></i>
          Go Back
        </div>
        <div className={`permission-header`} style={{ color: primary_color }}>
          <div className='d-flex align-items-center'>
            <div style={{ flex: 1 }}>
              <span className='font-weight-bold'>{data?.updated_by}</span>
              {headlineFor(updatedRows)}
            </div>
            {data?.updated_at && <div>{moment.utc(data?.updated_at).format('MMM D  YYYY, HH:mm')}</div>}
          </div>
        </div>
        <div className='p-4'>
          {updatedRows.map((row, index) => {
            const originalRow = originalRows[index] || originalRows[0] || {}
            const displayRow = useLockerEditFields ? normalizeLockerEditRow(row) : row
            return (
              <div key={displayRow?.locker_number || displayRow?.item_id_label || index}>
                {fields?.map((item) => {
                  return (
                    <div className='d-flex mb-2 align-items-center' style={{ width: '100%' }} key={item.field_id}>
                      <div className='font-weight-bold mb-2' style={{ width: '40%' }}>
                        {item?.label}:
                      </div>
                      <div style={{ width: '30%' }}>{get(displayRow, item?.field_id)}</div>
                      {!useLockerEditFields &&
                        checkIsDataUpdated(originalRow, displayRow, item?.field_id) &&
                        get(originalRow, item?.field_id) && (
                          <div
                            style={{ width: '30%' }}
                            className={`${checkIsDataUpdated(originalRow, row, item?.field_id) ? 'p-2 bg-danger text-light' : ''}`}>
                            {get(originalRow, item?.field_id)}
                          </div>
                        )}
                    </div>
                  )
                })}
                <hr></hr>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

const MoveBookingLog = ({ data, onExpand, expandedId, parentPageName }) => {
  let updated_data = data?.updated_data && JSON.parse(data?.updated_data)
  let original_data = data?.original_data && JSON.parse(data?.original_data)
  const updatedRows = asLogRows(updated_data)
  const useLockerEditFields = isLockerEditLog(updatedRows) || updatedRows.some((row) => row?.academic_year || row?.locker_number)
  const fields = useLockerEditFields ? LOCKER_EDIT_LOG_FIELDS : legacyFields

  if (expandedId) {
    return (
      <ShowDifference
        data={data}
        onExpand={onExpand}
        updated_data={updated_data}
        original_data={original_data}
        fields={fields}
        useLockerEditFields={useLockerEditFields}></ShowDifference>
    )
  }
  return (
    <div className='d-flex align-items-center p-3' style={{ borderBottom: '1px solid #e0e0e0' }}>
      <div>
        <i
          class='fa-solid fa-arrow-up-right-from-square mr-2 cursor-pointer'
          style={{ color: primary_color }}
          onClick={() => {
            onExpand(data?.id)
          }}></i>
      </div>
      <div style={{ flex: 1 }}>
        <span className='font-weight-bold'>{data?.updated_by}</span>
        {headlineFor(updatedRows)}
      </div>
      {data?.updated_at && <div>{moment.utc(data?.updated_at).format('MMM D  YYYY, HH:mm')}</div>}
    </div>
  )
}

export default MoveBookingLog
